<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('account.title')}}</h2>
        <!-- <div class="p-grid p-text-center p-jc-center p-ai-center" style="min-height: calc(100vh - 250px)"> -->
        <div class="p-grid p-text-center p-jc-center p-ai-center p-pb-6">
            <div class="p-col p-sm-12 p-md-6 p-lg-4 p-pb-1 p-pl-2 p-pr-2">
              <a href="#/account/userinfo">
                <div class="box p-p-5">
                  <img src="assets/irinox/images/user-profile.svg" :alt="$t('account.userinfo')"/>
                  <p>{{$t('account.userinfo')}}</p>
                </div>
              </a>
            </div>
            <div class="p-col p-sm-12 p-md-6 p-lg-4 p-pb-1 p-pl-2 p-pr-2" v-if="role==='USER' || role.includes('SERVICE')">
              <a href="#/account/company">
                <div class="box p-p-5">
                  <img src="assets/irinox/images/company.svg" :alt="$t('account.company')"/>
                  <p>{{$t('account.company')}}</p>
                </div>
              </a>
            </div>
            <div class="p-col p-sm-12 p-md-6 p-lg-4 p-pb-1 p-pl-2 p-pr-2" v-if="role==='USER'">
              <a href="#/account/laboratories">
                <div class="box p-p-5">
                  <img src="assets/irinox/images/laboratories.svg" :alt="$t('account.laboratories')"/>
                  <p>{{$t('account.laboratories')}}</p>
                </div>
              </a>
            </div>
            <div class="p-col p-sm-12 p-md-6 p-lg-4 p-pb-1 p-pl-2 p-pr-2">
              <a href="#/account/preferences">
                <div class="box p-p-5">
                  <img src="assets/irinox/images/preferences.svg" :alt="$t('account.preferences')"/>
                  <p>{{$t('account.preferences')}}</p>
                </div>
              </a>
            </div>
            <div class="p-col p-sm-12 p-md-6 p-lg-4 p-pb-1 p-pl-2 p-pr-2" v-if="role!=='USER' && $config.sparePartsEnabled()">
              <a href="#/after-sales/orders">
                <div class="box p-p-5">
                  <img src="assets/irinox/images/shopping_cart_white.svg" :alt="$t('account.orders')"/>
                  <p>{{$t('account.orders')}}</p>
                </div>
              </a>
            </div>
        </div>
      </div>
    </div>
  <div class="footer-legal-content p-grid p-m-0">
    <div class="p-col footer-legal-content-text">
      <div>IRINOX S.p.A. - Via Caduti nei Lager, 1</div>
      <div>31015 Conegliano (TV) - Italy</div>
      <div>© 2021 IRINOX S.p.A - P.IVA 02152370264</div>
    </div>
    <div v-if="!$functions.isDemoMode(email)" class="p-col-fixed p-grid p-m-0 p-p-0">
      <div class="p-col-fixed p-pt-0 p-pb-0">
        <a :href="docsMapping[$i18n.locale=='en-US'? 'us' : $i18n.locale].privacy" target="_new">
          FreshCloud Privacy policy
        </a>
      </div>
      <div class="p-col-fixed p-pt-0 p-pb-0">
      <a :href="docsMapping[$i18n.locale=='en-US'? 'us' : $i18n.locale].tos" target="_new">
        FreshCloud Terms
      </a>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import docsMapping from "../../../public/json/docs_mapping.json";
export default {
    data() {
        return {
          docsMapping: docsMapping,
        };
    },
    computed: {
      ...mapGetters({
          role: 'userdata/role',
          email: 'userdata/email',
        }),
    },
}
</script>

<style scoped>
.box {
  background-color: #002445;
  color: #FFFFFF;
  font-size: 30px;
  font-weight: 600;
  border: 0.5px solid #E7E7E7;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  cursor: pointer;
}
.box img {
  height: 150px;
}

</style>